<ion-header>
  <ion-toolbar class="toolbar-with-closing-button !px-2 md:!px-4">
    <div slot="start" class="flex">
      <dojo-icon-button (click)="dismiss()" [icon]="'times'" />
    </div>
    <ion-title class="common-ion-title">
      <div class="flex items-center justify-center gap-2">
        <span class="shrink-0">Working Hours For</span>
        <dojo-single-select
          [formCtrl]="periodControl"
          [options]="availablePeriods()"
          [optionValue]="'id'"
          [optionLabel]="'name'"
          [placeholder]="'Select Period'"
          class="max-w-[240px]"
        />
      </div>
    </ion-title>
    <div slot="end" class="hidden md:flex md:w-8"></div>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false" class="flex flex-col">
  <div class="mx-auto flex h-full max-w-3xl flex-col">
    <div class="flex-shrink-0 px-2 py-3 md:px-4">
      <div class="flex flex-wrap gap-4 text-sm md:gap-6">
        <div>
          <span class="text-neutral-600">Total Hours:</span>
          <span class="ml-1 font-semibold">{{ totalHours() }}</span>
        </div>
        <div>
          <span class="text-neutral-600">Estimated Payout:</span>
          <span class="ml-1 font-semibold">{{ estimatedPayout() | currency: 'EUR' }}</span>
        </div>
        <div>
          <span class="text-neutral-600">Rate:</span>
          @if (!hourlyPaymentRate()) {
            <span class="ml-1 font-semibold">Not set</span>
          } @else {
            <span class="ml-1 font-semibold">{{ hourlyPaymentRate() | currency: 'EUR' }}/hour</span>
          }
        </div>
      </div>
    </div>

    <div class="min-h-0 flex-1 px-2 pb-4 md:px-4">
      <ag-grid-angular
        class="ag-theme-basic-table hours-grid h-full"
        [rowData]="workingHoursData()"
        [columnDefs]="columnDefs()"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>
    </div>
  </div>
</ion-content>

<ion-footer class="border-t border-neutral-200 shadow-none">
  <div class="flex flex-col gap-3 p-2 pb-6 md:flex-row md:justify-between md:p-4">
    @if (isReadonly()) {
      <dojo-button [fill]="'outline'" (click)="dismiss()"> Close </dojo-button>
    } @else {
      <dojo-button [fill]="'outline'" (click)="dismiss()"> Cancel </dojo-button>

      <div class="flex flex-col gap-3 md:flex-row">
        @if (isExistingRequest()) {
          <dojo-button [fill]="'outline'" (click)="saveDraft()" [disabled]="!hasChanges()">
            <dojo-icon [icon]="'floppy-disk'" class="mr-2" />
            Update Hours
          </dojo-button>
          @if (canSubmitForPeriod()) {
            <dojo-button [fill]="'solid'" (click)="submitHours()">
              <dojo-icon [icon]="'paper-plane'" class="mr-2" />
              {{ hasChanges() ? 'Update & Submit' : 'Submit' }}
            </dojo-button>
          }
        } @else {
          <dojo-button [fill]="'outline'" (click)="saveDraft()" [disabled]="!hasChanges()">
            <dojo-icon [icon]="'floppy-disk'" class="mr-2" />
            Save Draft
          </dojo-button>
          @if (canSubmitForPeriod()) {
            <dojo-button [fill]="'solid'" (click)="submitHours()" [disabled]="totalHours() === 0">
              <dojo-icon [icon]="'paper-plane'" class="mr-2" />
              Submit for Approval
            </dojo-button>
          }
        }
      </div>
    }
  </div>
</ion-footer>
